import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AppComponent } from "./app.component";
import { GenFeaturesModule } from "./generac/features/generac-features.module";
import { SpartacusModule } from "./spartacus/spartacus.module";
import { GenAppRoutingModule } from "./generac/router/app-routing.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthModule as SSOAuthModule } from "@auth0/auth0-angular";
import { genAuthConfig } from "./generac/configs/auth.config";


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    GenAppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    BrowserAnimationsModule,
    SSOAuthModule.forRoot(genAuthConfig),
    SpartacusModule,
    GenFeaturesModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent],
})
export class AppModule { }